import React from "react";

export default function NotFound() {
  return <h1>Oops... Page not found.</h1>;
}
